export default __webpack_public_path__ + "static/media/Nestjs.7d772c00.svg";